import { extensionFetchJson } from './extensionClient';

export interface SearchResult {
  symbol: string;
  shortname?: string;
  longname?: string;
  exchange: string;
  typeDisp: string;
  quoteType: string;
}

export async function searchSymbols(query: string): Promise<SearchResult[]> {
  const trimmed = query.trim();
  if (!trimmed) return [];
  
  const url = `https://query2.finance.yahoo.com/v1/finance/search?q=${encodeURIComponent(trimmed)}&quotesCount=10&newsCount=0`;
  try {
    const response = await extensionFetchJson<{ quotes: SearchResult[] }>(url, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });
    
    if (response.status < 200 || response.status >= 300) {
      throw new Error('Search request failed');
    }
    
    // Filter to equities, ETFs, and crypto
    const validTypes = new Set(['EQUITY', 'ETF', 'CRYPTOCURRENCY']);
    return (response.body.quotes || []).filter(q => validTypes.has(q.quoteType?.toUpperCase()));
  } catch (err) {
    console.error('Failed to search symbols', err);
    return [];
  }
}
